import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { SellerDTO } from "@shared/model/seller.model";
import { CodeTable } from "@shared/services/code-table/code-table.model";

export class SellerData {
	sellers: SellerDTO[];
	selected: SellerDTO;
}

@Component({
	selector: "app-seller-selector",
	templateUrl: "./seller-selector.component.html",
	styleUrl: "./seller-selector.component.scss",
	standalone: false
})
export class SellerSelectorComponent {
	constructor(
		public dialogRef: MatDialogRef<SellerSelectorComponent>,
		@Inject(MAT_DIALOG_DATA) public data: SellerData
	) { }

	onClose(element: CodeTable): void {
		this.dialogRef.close(element);
	}

	selectRole(element: SellerDTO) {
		this.data.selected = element;
		this.onClose(element);
	}
}